import { useState, useEffect, forwardRef, ComponentPropsWithoutRef } from 'react';
import { CONTENT_API_ENDPOINT } from '~/src/constants';
import { getCityInfo } from '~/src/api/content/geography/get-city-info';
import { ICurrentCity } from '~/src/store/reducers/city';
import { Logo, LogoImg } from './styled';

interface IProps extends ComponentPropsWithoutRef<'a'> {
    billingDomain?: string;
    cityData: ICurrentCity;
    href: string;
    maxWidth?: string;
}

const MenuLogo = forwardRef<HTMLAnchorElement, IProps>((
    { billingDomain, cityData, href, maxWidth },
    ref
): JSX.Element => {
    const [logo, updateLogo] = useState(cityData.logo);
    const getLogoData = async() => {
        const resp = await getCityInfo({ domain: billingDomain || 'perm', filter: ['logo'], active: false });

        if (resp.ok && resp.data?.logo) {
            updateLogo(`${resp.data.logo}`);
        }
    };

    useEffect(() => {
        if (billingDomain !== cityData.domain) {
            getLogoData();
        }
    }, []);

    return (
        <Logo href={href} data-test='menu-logo' ref={ref}>
            <LogoImg
                data-test='menu-logo-img'
                src={CONTENT_API_ENDPOINT + logo}
                alt={'Логотип Дом.ru'}
                maxWidth={maxWidth}
            />
        </Logo>
    );
});

export default MenuLogo;
